export default "__VITE_ASSET__sDMePAcN__"